module.exports = __webpack_public_path__ + "static/img/yy3.1e2a024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yy3.png
// module id = osdT
// module chunks = 1